<template>
  <v-sheet class="fill-height resman-left-nav-sub" >
    <v-navigation-drawer fixed :width="width" style="top: 50px; left: 92px; height: calc(100vh - 50px);">
      <v-list dense>
        <v-subheader>
          <v-icon class="resman-left-nav-icon">{{ parentIcon }}</v-icon> {{ parentTitle }}
        </v-subheader>
        <v-divider></v-divider>
        <template v-for="(item, index) in items">
          <v-divider v-if="item.divider" :key="index"></v-divider>
          <v-list-item v-else :key="index" link :to="{ name: 'GroupGLAccountBudgets', params: { groupId: item.groupId }}" active-class="currentRoute">
            <v-list-item-content>
              <v-list-item-title class="resman-left-nav-sub-title" v-resman-ellipses-title @click="exitNav">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>   
      <v-overlay :absolute="absolute"
                 :value="overlay" style="top: 50px; left: 92px;" @click.native="exitNav()">
      </v-overlay>
  </v-sheet>
</template>

<script>
  export default {
    name: 'LeftNavSub',
    components: {},
    props: {
      parentTitle: {},
      parentIcon: {},
      subItems: {},
      width: {},
    },
    data: function () {
      return {
        absolute: true,
        overlay: true,
      };
    },
    methods: {
      exitNav() {
        this.$emit('overlayClicked', true);        
      }
    },
    computed: {
      items() {
        var s = [];
        this.subItems.forEach((g) => {
          s.push(g);
          s.push({ divider: true });
        });
        return s;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .resman-left-nav-sub .v-navigation-drawer::v-deep .v-navigation-drawer__content {
    background-color: var(--v-resGrey-lighten4);
  }
  .resman-left-nav-sub .resman-left-nav-sub-title {
    color: var(--v-resGrey-darken1);
  }
  .resman-left-nav-sub .v-navigation-drawer::v-deep .v-navigation-drawer__content .v-list {
    background-color: white;
    padding-bottom: 0px;
    padding-top: 0px;
  }
  .resman-left-nav-sub .currentRoute {
    .resman-left-nav-sub-title {
      color: var(--v-resBlue-darken1) !important;
    }
  }
  .resman-left-nav-sub .v-list-item:hover {
    background-color: var(--v-resBlue-darken1) !important;
    .resman-left-nav-sub-title {
      color: white !important;
    } 
  }
  .resman-left-nav-sub .currentRoute::before {
    opacity: 0;
  }
  .resman-left-nav-sub .v-list-item--active:hover::before {
    opacity: 0.12;
  }

  .resman-left-nav-sub .v-subheader {
    background-color: var(--v-resGrey-lighten4);
    color: var(--v-resGrey-darken1);
    height: 46px;
  font-size: 14px;
    .resman-left-nav-icon {
      margin-right: 5px;
    }
  }
</style>
